// src/security/initGlobalSecurity.js
import DOMPurify from "dompurify";

const sanitizeInput = (value) => {
  return DOMPurify.sanitize(value, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
  });
};

export const initGlobalSecurity = () => {
  // 🛡️ Sanitize URL parameters
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  let modified = false;
  for (const [key, value] of params.entries()) {
    if (/[<>"'(){}[\];]/.test(value)) {
      console.warn(`Malicious param removed: ${key}=${value}`);
      params.delete(key);
      modified = true;
    }
  }

  if (modified) {
    const newUrl = url.origin + url.pathname + "?" + params.toString();
    window.history.replaceState({}, "", newUrl);
  }

  const setupInputSanitizer = () => {
    // Sanitize on blur and paste via event delegation
    document.addEventListener(
      "blur",
      function (e) {
        if (e.target.matches("input, textarea")) {
          e.target.value = sanitizeInput(e.target.value);
        }
      },
      true
    );

    document.addEventListener(
      "paste",
      function (e) {
        if (e.target.matches("input, textarea")) {
          e.preventDefault();
          const pastedData = (e.clipboardData || window.clipboardData).getData(
            "text"
          );
          const sanitized = sanitizeInput(pastedData);
          // Insert the sanitized paste data
          const start = e.target.selectionStart;
          const end = e.target.selectionEnd;
          const original = e.target.value;
          e.target.value =
            original.slice(0, start) + sanitized + original.slice(end);
          // Move cursor
          e.target.selectionStart = e.target.selectionEnd =
            start + sanitized.length;
        }
      },
      true
    );
    // Sanitize all inputs on form submit
    document.addEventListener(
      "submit",
      function (e) {
        const inputs = e.target.querySelectorAll("input, textarea");
        inputs.forEach((input) => {
          input.value = sanitizeInput(input.value);
        });
      },
      true
    );
  };

  // Wait until DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupInputSanitizer);
  } else {
    setupInputSanitizer();
  }
};
